<template>
	<el-card class="box-card" id='screenDialog'>
		<el-form label-width="70px" inline label-position="right">
			<!-- <div class='dates'>
			  	<div class='publicTitle'>
			  	  	期间
			  	</div>
			  	<el-date-picker
					size='mini'
				    v-model="dateList"
				    type="monthrange"
				    value-format='yyyyMM'
				    range-separator="至"
				    start-placeholder="开始月份"
				    end-placeholder="结束月份">
				</el-date-picker>
			</div> -->
			<div class='attribute nodates'>
				<div class='publicTitle'>
			  	  	分录属性
			  	</div>
			  	<el-form-item label='摘要'>
			  		<el-input placeholder = "请输入摘要" size='mini' v-model='form.summary' style="width: 267px;" clearable></el-input>
			  	</el-form-item>
			</div>
			<div class='attribute'>
				<div class='publicTitle'>
			  	  	其他
			  	</div>
			  	<el-form-item label="金额">
					<el-select size="small" style="width: 94px;" v-model='form.foreignCurrencyId' clearable>
						<el-option v-for='i in foreignCurrencyList' :label="i.name" :value="i.id" :key='i.id'></el-option>
					</el-select>
					<el-input size="small" style="width: 65px;" v-model='form.startMoney' placeholder='始' ref='startMoneys' clearable></el-input><span class="mids">至</span>
					<el-input size="small" style="width: 65px;" v-model='form.endMoney' placeholder='终' clearable></el-input>
				</el-form-item>
				<el-form-item label="制单人">
					<el-input size="small" placeholder="请输入制单人" style="width: 267px;" v-model='form.createName' clearable></el-input>
				</el-form-item>
				<!-- <el-form-item label="标记">
						<el-select size="small" style="width: 94px;" v-model='form.signId' >
							<el-option v-for='i in dropDownList' :label="i.name" :value="i.id" :key='i.id'></el-option>
						</el-select>
						<el-input v-model='form.signReason' size="small" style="width: 170px;" placeholder="请输入标记原因"></el-input>
				</el-form-item> -->
				<el-form-item class="btn-align">
					<el-button size="small" @click='Reset' class='secondaryButton'>重置</el-button>
					<el-button class='minButton' size="small" @click='handleSearch'>搜索</el-button>
				</el-form-item>
			</div>
		</el-form>
	</el-card>
</template>
<script>
	export default {
		props: {
			
		},
		data() {
			return {
				foreignCurrencyList:[],
				dropDownList:[],
				//dateList:[],
				form:{
					//startYearPeriods:"",  // 开始期数
					//endYearPeriods:"",  // 结束期数
					summary:"",
					foreignCurrencyId:"",
					startMoney:"",
					endMoney:"",
					createName:"",
					signId:0,
					signReason:"",
				}
			}
		},
		created() {
			this.getForeignCurrency();
			this.getDropDown();
		},
		computed: {
			
		},
		methods: {
			Reset() {
				this.form = Object.assign(this.form,{
					//startYearPeriods:"",  // 开始期数
					//endYearPeriods:"",  // 结束期数
					summary:"",
					foreignCurrencyId:"",
					startMoney:"",
					endMoney:"",
					createName:"",
					signId:"",
					signReason:"",
				})

				this.$emit('formMessage' , this.form);
			},
			handleSearch() {
				let reg = /^[+-]?\d*\.?\d*$/;
				if(!reg.test(this.form.startMoney) || !reg.test(this.form.endMoney)) {
					return this.$message.warning('金额应该为数字！')
				}
				// if(this.dateList.length) {
				// 	this.form.startYearPeriods = this.dateList[0];
				// 	this.form.endYearPeriods = this.dateList[1];
				// }
				this.$emit('formMessage' , this.form);
			},
			// 获取查询凭证的标记下拉选项
			getDropDown() {
				this.$http.post('voucherChief/getDropDown',{}).then(res=>{
					if(res.data&&res.data.code) {
						this.dropDownList = res.data.data;
					}
				})
			},
			// 获取外币核算
			getForeignCurrency(){
				const _=this;
				_.$http.post('foreignCurrency/findAll',{}).then((res)=>{
					if(res && res.data.code == '1'){
						let list =  res.data.data;
						this.foreignCurrencyList = list;
						this.form.foreignCurrencyId = list.length?list[0].id:"";
					}
				})
			},
			
		},
		watch: {
			
		}
	}
</script>
<style lang='less'>
	#screenDialog {
		width: 388px;
		line-height: 14px;
		.el-form-item {
			padding: 2px 0;
			position: relative;
		}
		.mid{
			padding:0 15px;
		}
		.mids{
			padding:0 10px;
		}
		.el-form--label-right{
			.el-form-item__label{
				text-align: right;
			}
		}
		.btn-align{
			width:100%;
			text-align: center;
			margin-top: 30px;
			.el-form-item__content{
				width: 100%;
			}
		}
		.attribute {
			margin-top: 30px;
		}
		.nodates {
			margin-top: 0 !important;
		}
		.publicTitle {
			color: #333;
			margin-bottom: 15px;
			font-weight: 600;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/voucher/components/screenDialog.vue